import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import moment from 'moment'; // claude changes: needed for format() and parse() overrides below



@Injectable()
export class MexicoDateAdapter extends NativeDateAdapter {

  // claude changes: NativeDateAdapter.format() spreads the displayFormat as Intl.DateTimeFormat options.
  // When a moment-style string like 'HH:mm' or 'YYYY-MM-DD' is passed, spreading a string as an object
  // produces {0:'H',1:'H',...} which Intl ignores and falls back to a full date string.
  // Fix: if the format is a string, delegate to moment.js which understands these patterns.
  override format(date: Date, displayFormat: any): string {
    if (typeof displayFormat === 'string') {
      return moment(date).format(displayFormat);
    }
    return super.format(date, displayFormat); // native path for Intl option objects
  }

  // claude changes: same problem as format() — NativeDateAdapter.parse() does not understand
  // moment-style format strings. If both value and parseFormat are strings, use moment to parse.
  override parse(value: any, parseFormat?: any): Date | null {
    if (typeof value === 'string' && typeof parseFormat === 'string') {
      const m = moment(value, parseFormat, true); // strict mode
      return m.isValid() ? m.toDate() : null;
    }
    return super.parse(value, parseFormat);
  }

  override toIso8601(date: Date): string {
    const year = date.getFullYear();
    const month = this._to2digit(date.getMonth() + 1);
    const day = this._to2digit(date.getDate());
    return `${year}-${month}-${day}`;
  }

  override deserialize(value: any): Date | null {
    // claude changes: added !value.includes('T') guard — original split on '-' would fire on ANY string,
    // including time strings like "12:30" (no dash) but also ISO strings like "2026-04-21T14:00:00"
    // where splitting gives wrong parts. Only handle plain YYYY-MM-DD date strings locally.
    if (typeof value === 'string' && value.includes('-') && !value.includes('T')) {
      const [y, m, d] = value.split('-').map(Number);
      return new Date(y, m - 1, d); // DO NOT use UTC here
    }
    return super.deserialize(value);
  }

  private _to2digit(n: number) {
    return ('00' + n).slice(-2);
  }
}
import { MatDateFormats } from '@angular/material/core';

export const MEXICO_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'YYYY-MM-DD',  // Input from MySQL style dates
    timeInput: 'HH:mm',
  },
  display: {
    dateInput: 'YYYY-MM-DD',  // How Angular shows date in input
    monthYearLabel: 'YYYY MMM',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY MMMM',
    timeInput: 'HH:mm',
    timeOptionLabel: 'HH:mm',
  }
};
